import { FC } from 'react'
import { SkeletonBarProps } from './SkeletonBar.types'
import { StyledSkeletonBar } from './SkeletonBar.styles'

const SkeletonBar: FC<SkeletonBarProps> = ({
    width = 120,
    height = 20,
    borderRadius = 4,
    className,
    dataTestId,
}) => {
    return (
        <StyledSkeletonBar
            width={width}
            height={height}
            borderRadius={borderRadius}
            className={className}
            data-testid={dataTestId}
        />
    )
}

export default SkeletonBar
